import React from 'react';
import {
  CustommerTypeCookieName,
  setCookie,
} from '../pages/Basepage/parts/CookieManager';
import LabelInput from './LabelImput';

interface BuchhandlerInputProp {
  isNotValidExit: boolean;
  cookieDomain: string;
}

export default class BuchhandlerInput extends React.Component<BuchhandlerInputProp> {
  render() {
    return (
      <>
        <LabelInput
          id="verkehrsnummer"
          labelText="Verkehrsnummer"
          type="text"
          name="verkehrsnummer"
          requied={true}
        />
        {this.props.isNotValidExit ? (
          <fieldset>
            <span>Sind Sie Buchhändler?</span>
            <br />
            <input type="radio" name="handler" id="yes_handler" value={'yes'} />
            <label htmlFor="yes_handler">Ja*</label>
            <br />
            <input
              type="radio"
              name="handler"
              id="no_handler"
              value={'no'}
              onClick={() => {
                let windowAny: any = window;

                windowAny.historyHelper.memory.push('/onlyb2b', null);
              }}
            />
            <label htmlFor="no_handler">Nein</label>
            <br />
            <span>
              * Mit einem Klick auf "Ja" bestätige ich, dass ich als Buchhändler
              tätig bin und nur in dieser Eigenschaft bei Buchbutler
              Bestellungen tätige. Mir ist bewusst, dass ich alle Bücher, die
              der Preisbindung unterliegen, nicht unter dem gebundenen
              Ladenpreis an Endkunden verkaufen darf.
            </span>
          </fieldset>
        ) : (
          <>
            <input type="checkbox" name="handler" id="handler" />
            <label htmlFor="handler">
              Hiermit bestätige ich, dass ich als Buchhändler tätig bin und nur
              in dieser Eigenschaft bei Buchbutler Bestellungen tätige. Mir ist
              bewusst, dass ich alle Bücher, die der Preisbindung unterliegen,
              nicht unter dem gebundenen Ladenpreis an Endkunden verkaufen darf.
            </label>
          </>
        )}

        <br />
      </>
    );
  }
}
